import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendarMinus} from '@fortawesome/pro-solid-svg-icons';
import {type IAsset} from '@netx/core-asset-next/schema';
import {canUnexpireAsset} from '../enablers/canUnexpireAsset';
import {AssetExpirationActionLabel} from '../locales';

export const assetExpirationActionUnexpireIcon = faCalendarMinus;

export type AssetExpirationActionUnexpireParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (asset: IAsset) => void;
};

/**
 * Unexpire asset
 * @param params
 * @returns Action
 */
export const assetExpirationActionUnexpire = (
	asset: IAsset,
	{cb, ...params}: AssetExpirationActionUnexpireParams,
): ReactAction => ({
	name: 'asset-expiration-unexpire',
	cb: () => cb(asset),
	enableTest: () => canUnexpireAsset(asset),
	icon: assetExpirationActionUnexpireIcon,
	get label() {
		return AssetExpirationActionLabel.UNEXPIRE;
	},
	...params,
});

export default assetExpirationActionUnexpire;
